module.exports = __webpack_public_path__ + "static/img/2705_phase_function_Paper_PointsHejduk_Prediction.d8ffc72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2705_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Or7F
// module chunks = 0